module.exports = __webpack_public_path__ + "img/icon_steem.655a6ec9.svg";